import { Injectable } from '@angular/core';
import { OrganisationV2Api } from '@assetaccountant/api/services/organisation-v2.api';
import { Subscription } from 'rxjs';
import { FeatureFlagService } from './feature-flag.service';

/**
 * Loads the active organisation's Feature Hub flags into FeatureFlagService. Kept apart from that
 * service because it needs HttpClient, and the HTTP interceptor depends on FeatureFlagService.
 */
@Injectable({ providedIn: 'root' })
export class FeatureFlagLoaderService {
  private organisationId?: number;
  private request?: Subscription;

  constructor(
    private organisationApi: OrganisationV2Api,
    private featureFlags: FeatureFlagService,
  ) {}

  /** Loads the organisation's flags, unless they're already loaded (or loading) for it. */
  loadForOrganisation(organisationId: number) {
    if (organisationId === this.organisationId) {
      return;
    }

    this.organisationId = organisationId;
    this.request?.unsubscribe();
    // Don't let the previous organisation's flags apply while this one's are loading.
    this.featureFlags.setFeatureHubFlags({});

    this.request = this.organisationApi.listFeatureFlags(organisationId).subscribe({
      next: response =>
        this.featureFlags.setFeatureHubFlags(
          Object.fromEntries(response.features.map(f => [f.key, f.value])),
        ),
      error: error => {
        // Flags stay off. Forget the organisation so the next navigation tries again.
        this.organisationId = undefined;
        console.error('Failed to load feature flags', error);
      },
    });
  }
}
